export interface ParseNDECsvResult {
  data: number[][]
  error?: string
}

function parseSimpleCsv(content: string): string[][] {
  const lines = content.split(/\r?\n/)
  const result: string[][] = []

  for (const line of lines) {
    const trimmedLine = line.trim()
    if (trimmedLine.length === 0) continue

    const cells = trimmedLine.split(',').map((cell) => cell.trim())
    result.push(cells)
  }

  return result
}

export function parseNDECsv(fileContent: string): ParseNDECsvResult {
  try {
    const parsed = parseSimpleCsv(fileContent)

    if (parsed.length === 0) {
      return {
        data: [],
        error: 'CSV file is empty',
      }
    }

    const data: number[][] = []
    let rowIndex = 0

    for (const row of parsed) {
      rowIndex++
      const numericRow: number[] = []

      for (let colIndex = 0; colIndex < row.length; colIndex++) {
        const cell = row[colIndex]

        if (cell === '' || cell === null || cell === undefined) {
          continue
        }

        const num = parseFloat(cell)

        if (isNaN(num)) {
          return {
            data: [],
            error: `Invalid numeric value at row ${rowIndex}, column ${colIndex + 1}: "${cell}"`,
          }
        }

        numericRow.push(num)
      }

      if (numericRow.length > 0) {
        data.push(numericRow)
      }
    }

    if (data.length === 0) {
      return {
        data: [],
        error: 'No valid numeric data found in CSV',
      }
    }

    return { data }
  } catch (error) {
    return {
      data: [],
      error: `Failed to parse CSV: ${error instanceof Error ? error.message : 'Unknown error'}`,
    }
  }
}
